import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "b-profile-calendar-page h-pos-rel" }
const _hoisted_2 = { class: "h-bold h-mv-0 h-ml-10 h-font-14" }
const _hoisted_3 = {
  key: 2,
  style: {"width":"760px"},
  class: "h-flex h-flex-justify-start"
}
const _hoisted_4 = {
  key: 1,
  class: "b-profile-calendar-page__inner h-pos-rel"
}
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "h-pos-rel" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "b-choose__wrapper h-mt-50" }
const _hoisted_9 = { class: "b-choose-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "h-flex h-align-items-center h-flex-justify-center"
}
const _hoisted_11 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_12 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_13 = {
  key: 1,
  class: "h-flex h-align-items-center h-flex-justify-center"
}
const _hoisted_14 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_15 = {
  key: 2,
  class: "h-flex h-align-items-center h-flex-justify-center"
}
const _hoisted_16 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_17 = {
  key: 3,
  class: "h-opacity-0_5 h-font-10 h-fw-700 qa-profile-calendar-status-sync"
}
const _hoisted_18 = { class: "b-choose-wrapper h-ml-25" }
const _hoisted_19 = {
  key: 0,
  class: "h-flex h-align-items-center h-flex-justify-center"
}
const _hoisted_20 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_21 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_22 = {
  key: 1,
  class: "h-flex h-align-items-center h-flex-justify-center"
}
const _hoisted_23 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_24 = {
  key: 2,
  class: "h-flex h-align-items-center h-flex-justify-center"
}
const _hoisted_25 = { class: "h-opacity-0_5 h-font-10 h-fw-700 h-ml-5" }
const _hoisted_26 = {
  key: 3,
  class: "h-opacity-0_5 h-font-10 h-fw-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_ProfileCalendarListPage = _resolveComponent("ProfileCalendarListPage")!
  const _component_FwImage = _resolveComponent("FwImage")!
  const _component_InformationCalendarSyncPopup = _resolveComponent("InformationCalendarSyncPopup")!
  const _component_InformationPopup = _resolveComponent("InformationPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isListShown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "b-back-button h-inline-flex h-pointer",
          style: {"left":"120px","top":"75px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToMainPage && _ctx.backToMainPage(...args)))
        }, [
          _createVNode(_component_FwIcon, {
            class: "h-flex-center h-pointer",
            icon: "arrow-left",
            size: "14",
            color: "rgba(33,63,107,.3)"
          }),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('BUTTON.BACK')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 1,
          colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
          class: "h-flex-center loader",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.calendarList && _ctx.isListShown && !_ctx.isInfoPopup)
            ? (_openBlock(), _createBlock(_component_ProfileCalendarListPage, {
                key: 0,
                list: _ctx.calendarList,
                remoteData: _ctx.remoteDataForCheckbox,
                platform: _ctx.platform,
                errorCalendarReasonMessage: _ctx.errorCalendarReasonMessage,
                onBackToMainPage: _ctx.backToMainPage,
                onGetStatus: _ctx.getCalendarStatus,
                onGetCalendars: _ctx.getCalendars
              }, null, 8, ["list", "remoteData", "platform", "errorCalendarReasonMessage", "onBackToMainPage", "onGetStatus", "onGetCalendars"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('CALENDAR-SYNC.TITLE')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('CALENDAR-SYNC.TEXT.BODY')), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["b-choose .qa-profile-calendar-google-button", {"b-choose-prevented": !_ctx.isDesyncGoogleEnd && _ctx.timerValueGoogle && _ctx.desyncGooglePlatform}]),
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showGoogleInfoByStatus && _ctx.showGoogleInfoByStatus(...args)))
                      }, [
                        _createVNode(_component_FwImage, {
                          class: "h-mt-25",
                          src: _ctx.requireImage("google-icon.svg"),
                          height: "60px"
                        }, null, 8, ["src"]),
                        _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "h-mt-25 h-ph-20 h-font-14 h-text-center" }, " GOOGLE CALENDAR ", -1)),
                        (!_ctx.isDesyncGoogleEnd && _ctx.timerValueGoogle && _ctx.desyncGooglePlatform)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_FwIcon, {
                                class: "h-mh-5",
                                icon: "circle-arrows",
                                size: "20",
                                color: "#27dbbd"
                              }),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('LABEL.DESYNCHRONISATION')), 1),
                              _createElementVNode("span", _hoisted_12, " (" + _toDisplayString(_ctx.timerValueGoogle) + ") ", 1)
                            ]))
                          : (_ctx.isGoogleAuthorizedNeeded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_FwImage, {
                                  src: _ctx.requireImage("warning-icon.svg")
                                }, null, 8, ["src"]),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('CALENDAR-SYNC.AUTH.NEEDED')), 1)
                              ]))
                            : (_ctx.googleCalendarExist && _ctx.googleCalendarExist.sync_status === "failed")
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_FwImage, {
                                    src: _ctx.requireImage("warning-icon.svg")
                                  }, null, 8, ["src"]),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('CALENDAR-SYNC.ERROR')), 1)
                                ]))
                              : (_ctx.isGoogleCalendarSynced)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('CALENDAR-SYNC.SYNCHRONIZED')), 1))
                                : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["b-choose", {"b-choose-prevented": !_ctx.isDesyncOutlookEnd && _ctx.timerValueOutlook && _ctx.desyncOutlookPlatform}]),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showOutlookInfoByStatus && _ctx.showOutlookInfoByStatus(...args)))
                      }, [
                        _createVNode(_component_FwImage, {
                          class: "h-mt-25",
                          src: _ctx.requireImage("outlook-icon.svg"),
                          height: "60px"
                        }, null, 8, ["src"]),
                        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "h-mt-25 h-ph-20 h-font-14 h-text-center" }, " OUTLOOK CALENDAR ", -1)),
                        (!_ctx.isDesyncOutlookEnd && _ctx.timerValueOutlook && _ctx.desyncOutlookPlatform)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_FwIcon, {
                                class: "h-mh-5",
                                icon: "circle-arrows",
                                size: "20",
                                color: "#27dbbd"
                              }),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('LABEL.DESYNCHRONISATION')), 1),
                              _createElementVNode("span", _hoisted_21, " (" + _toDisplayString(_ctx.timerValueOutlook) + ") ", 1)
                            ]))
                          : (_ctx.isOutlookAuthorizedNeeded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_FwImage, {
                                  src: _ctx.requireImage("warning-icon.svg")
                                }, null, 8, ["src"]),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('CALENDAR-SYNC.AUTH.NEEDED')), 1)
                              ]))
                            : (_ctx.outlookCalendarExist && _ctx.outlookCalendarExist.sync_status === "failed")
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(_component_FwImage, {
                                    src: _ctx.requireImage("warning-icon.svg")
                                  }, null, 8, ["src"]),
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('CALENDAR-SYNC.ERROR')), 1)
                                ]))
                              : (_ctx.isOutlookCalendarSynced)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('CALENDAR-SYNC.SYNCHRONIZED')), 1))
                                : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ])
                ])
              ]))
        ])),
    (_ctx.isInfoPopup)
      ? (_openBlock(), _createBlock(_component_InformationCalendarSyncPopup, {
          key: 3,
          buttonId: "google-signin-btn",
          headerText: "Important",
          bodyText: _ctx.$t(`CALENDAR-SYNC.POPUP.TEXT`),
          buttonText: _ctx.$t(`CALENDAR-SYNC.POPUP.BUTTON.TEXT`),
          onOnSignIn: _ctx.onSignIn,
          onClose: _ctx.closeInfoPopup,
          onCloseSuccess: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isInfoPopup = false))
        }, null, 8, ["bodyText", "buttonText", "onOnSignIn", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isErrorPopup)
      ? (_openBlock(), _createBlock(_component_InformationPopup, {
          key: 4,
          errorMessage: _ctx.errorReasonMessage,
          headerText: _ctx.$t(`CALENDAR-SYNC.POPUP.ERROR.TITLE`),
          bodyText: _ctx.$t(`CALENDAR-SYNC.POPUP.ERROR.TEXT`),
          buttonText: _ctx.noRemoteEventsErrorText ? _ctx.$t(`POPUP.FINALY.CLOSE`) : _ctx.$t(`CALENDAR-SYNC.POPUP.ERROR.BUTTON`),
          onGoToPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.noRemoteEventsErrorText ? null : _ctx.onSignIn)),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isErrorPopup = false))
        }, null, 8, ["errorMessage", "headerText", "bodyText", "buttonText"]))
      : _createCommentVNode("", true)
  ]))
}